import firebase from "firebase/app";
import fc from "@/firebaseConfig";

const axios = require("axios");

export default async function updatePackage(packageObject, companyID, isCreate) {
  let token = await firebase.auth().currentUser.getIdToken(/* forceRefresh */ false)
    .then(function (idToken) {
      return idToken
    });

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': 'JWT ' + token
  }

  return await axios.post(fc.cloudFunctionUrl + "updateCompanyPlan", {packageObject: packageObject, companyID, isCreate}, {headers})
    .then((response) => response)
    .catch((error) => {
      console.log(error)
    })
}
